import React, { useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import styles from "./LoadDealerPricing.module.scss";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import ClearIcon from "@mui/icons-material/Clear";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import AlertToolTip from "../../../../shared/sharedToolTip/AlertToolTip";

const LoadDealerPricing = (props) => {
  const [sortDir, setSortDir] = useState(undefined);
  const [sortKey, setSortKey] = useState(undefined);

  const validationInvalidFormat =
    props.t("PaymentThreshold.validations.invalidFormat") || "";
  const validationRequired = "Value is required";

  const dealerInventaryApprovePermission =
    props.user.permissions.rolePermissions.hasOwnProperty(
      "dealerInventoryApprove:write"
    );

  const disableCheckbox =
    dealerInventaryApprovePermission === false ||
    props.user.dealerType === "BRAN";

  const showAlertIcon = props.user.permissions.rolePermissions.hasOwnProperty(
    "dealerInventoryApprove:write"
  );

  const handleSort = (sortKeyParam, newDirection, sortByString) => {
    setSortKey(sortKeyParam);
    setSortDir(newDirection);
    props.loadDealerInventoryPricingHistory(sortByString);
  };

  const displayDepositPrice = (item, defaultCurrency) => {
    if (
      item.currencyAdjustedPrice !== null &&
      (!!item.currencyAdjustedPrice || item.currencyAdjustedPrice >= 0)
    ) {
      return (
        <div>
          <span>
            {defaultCurrency ? defaultCurrency.symbol : ""}{" "}
            {parseFloat(item.currencyAdjustedPrice).toFixed(2)}
          </span>
        </div>
      );
    }
  };

  const displayPreviousPrice = (item, defaultCurrency) => {
    if (
      item.previousAdjustedPrice !== null &&
      item.previousAdjustedPrice >= 0
    ) {
      return (
        <div className={styles.previousDiv}>
          <span id="model" className={styles.previousPrice}>
            {defaultCurrency ? defaultCurrency.symbol : ""}{" "}
            {parseFloat(item.previousAdjustedPrice).toFixed(2)}
          </span>
        </div>
      );
    } else {
      return (
        <div className={styles.previousDiv}>
          <span id="model" className={styles.previousPrice}>
            -
          </span>
        </div>
      );
    }
  };

  const showInventoryConfirmation = (v) => {
    props.showInventoryConfirmation(v);
  };

  const roundToTwoDecimal = (num) => {
    if (num % 1 !== 0) {
      let value = +(Math.round(num + "e+2") + "e-2");
      const length =
        value &&
        value.toString().split(".")[1] &&
        value.toString().split(".")[1].length;
      if (length === 0) {
        value = value + ".00";
      } else if (length === 1) {
        value = value + "0";
      }
      return value;
    } else {
      return num ? num.toString() + ".00" : "-";
    }
  };

  const getSortString = (sortKeyParam) => {
    let newDirection = "DSC";
    if (sortKeyParam === sortKey) {
      newDirection = sortDir === "ASC" ? "DSC" : "ASC";
    }

    if (sortKeyParam === "currencyAdjustedPrice") {
      newDirection === "ASC"
        ? handleSort(sortKeyParam, newDirection, "currencyAdjustedPrice.ASC")
        : handleSort(sortKeyParam, newDirection, "currencyAdjustedPrice.DSC");
    } else if (sortKeyParam === "modelYear") {
      newDirection === "ASC"
        ? handleSort(sortKeyParam, newDirection, "modelYear.ASC")
        : handleSort(sortKeyParam, newDirection, "modelYear.DSC");
    }
  };

  const checkedCheckbox = (price) => {
    if (props.isMEXMarket) {
      return price.vehicleSuppressedByDealer;
    }
    return price.priceModified
      ? price.checked
      : price.checked || price.published;
  };

  const validatePrice = (value) => {
    if (!value) return validationRequired;
    if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(value)) return validationInvalidFormat;
    if (parseFloat(value) < 0) return validationInvalidFormat;
    return "";
  };

  const { defaultCurrency } = props.localizedInfo || {
    defaultCurrency: { symbol: "" },
  };

  return (
    <div id="inventoryPrices">
      {/* Header - same as before */}
      <Grid
        container
        spacing={0}
        mt={1}
        className={`${styles.tableRowHeader} ${styles.cellSpacing} pagePaddingLeft pagePaddingRight`}
      >
        {/* ... all header code stays the same ... */}
        {props.showValidatdColumn && showAlertIcon && !props.isMEXMarket && (
          <Grid item className={styles.alertCell} />
        )}
        {props.showValidatdColumn && (
          <Grid item className={styles.reservationEditPrice}>
            <span
              id="model"
              className={`${styles.priceValidatedAllCheckBox} ${
                props.userDetails.market === "ARG"
                  ? styles.AllCheckBoxLeftPadding
                  : ""
              } ${props.isMEXMarket ? "" : styles.flex}`}
            >
              {props.isMEXMarket
                ? props.t("UploadDealerPrice.suppress")
                : props.t("UploadDealerPrice.validated")}
              {!props.isMEXMarket && (
                <CheckBox
                  id="checkAllBoxes"
                  checked={props.allChecked}
                  isDisabled={disableCheckbox}
                  onChange={props.checkAllCheckBox}
                />
              )}
            </span>
          </Grid>
        )}
        <Grid item className={styles.specificationColumn}>
          <span
            id="model"
            className={`${styles.reservationInputGridModel} ${styles.specification_header}`}
          >
            {props.t("UploadDealerPrice.specification")}
          </span>
        </Grid>
        <Grid item className={styles.vinColumn}>
          <span id="model" className={styles.reservationInputGridModel}>
            {props.t("UploadDealerPrice.vin")}
          </span>
        </Grid>
        <Grid
          item
          className={`${styles.modelYearColumn} ${styles.sort}`}
          onClick={() => getSortString("modelYear")}
        >
          <div id="model" className={styles.reservationInputGridModel}>
            {props.t("UploadDealerPrice.modelYear")}
            <SortingIcon
              currentKey="modelYear"
              sortKey={sortKey}
              sortDirection={sortDir}
            />
          </div>
        </Grid>
        {!props.hideUsdPrice && !props.isMEXMarket && (
          <Grid item className={styles.usdConversionColumn}>
            <span id="model" className={styles.reservationInputGridModel}>
              {props.t("UploadDealerPrice.usdCustomerPrice")}
            </span>
          </Grid>
        )}
        {!props.isMEXMarket && (
          <Grid item className={styles.previousPriceColumn}>
            <span id="model" className={styles.reservationInputGridModel}>
              {props.t("UploadDealerPrice.previousAdjustedPrice")}
            </span>
          </Grid>
        )}
        {!props.isMEXMarket && (
          <Grid item className={styles.previousPriceEffectiveDateColumn}>
            <span id="model" className={styles.reservationInputGridModel}>
              {props.t("UploadDealerPrice.previousAdjustedPriceEffectiveDate")}
            </span>
          </Grid>
        )}
        {!props.isMEXMarket && (
          <Grid
            item
            className={`${styles.arsAdjustedPriceColumn}  ${styles.sort}`}
            onClick={() => getSortString("currencyAdjustedPrice")}
          >
            <div className={styles.reservationInputGridModel}>
              {props.t("UploadDealerPrice.arsAdjustedPrice")}
              <SortingIcon
                currentKey="currencyAdjustedPrice"
                sortKey={sortKey}
                sortDirection={sortDir}
              />
            </div>
          </Grid>
        )}
        {!props.isMEXMarket && (
          <Grid item className={styles.spacer}>
            <HasPermissionTo
              perform={["dealerInventoryApprove:write"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => (
                <div
                  className={`${styles.Edit} ${
                    props.editButtonDisable && styles.disabled
                  }`}
                  id="editReservations"
                  data-testid="editReservations"
                  onClick={props.editReservations}
                >
                  <div className={styles.RectangleStart}>&nbsp;</div>
                  <div id="pencilIcon" className={styles.RectangleEnd}>
                    &nbsp;
                  </div>
                </div>
              )}
            />
          </Grid>
        )}
        <Grid item className={styles.effectiveDateColumn}>
          <div className={styles.reservationInputGridRightCell}>
            {props.t("UploadDealerPrice.effectiveDate")}
          </div>
        </Grid>
        {props.showValidatdColumn && (
          <Grid item className={styles.blankColumn}></Grid>
        )}
      </Grid>

      {/* Rows */}
      <div className={styles.topMarginGridContent}>
        {props.selectedPrices &&
          props.selectedPrices.map((price, index) => {
            const error = props.editMode
              ? validatePrice(price.currencyAdjustedPrice)
              : "";

            return (
              <Grid
                container
                spacing={0}
                mt={1}
                className={`${styles.cellSpacing} pagePaddingLeft pagePaddingRight`}
                key={"selectedPrice-" + price.vin + "-" + index}
              >
                {props.showValidatdColumn &&
                  showAlertIcon &&
                  !props.isMEXMarket && (
                    <Grid item className={styles.alertCell}>
                      {!price.published && (
                        <div className={styles.alertIcon}>
                          <AlertToolTip
                            body={props.t(
                              "ModifyReservationPrice.priceNeedsToBeValidated"
                            )}
                          />
                        </div>
                      )}
                    </Grid>
                  )}
                {props.showValidatdColumn && (
                  <Grid item className={styles.reservationEditPrice}>
                    <div className={styles.checkBoxDiv}>
                      <CheckBox
                        id={`checkbox${index}`}
                        key={`checkbox${index}-${price && price.checked}`}
                        value={index}
                        checked={checkedCheckbox(price)}
                        isDisabled={disableCheckbox}
                        onChange={props.clickCheckBox}
                      />
                    </div>
                  </Grid>
                )}
                <Grid item className={styles.specificationColumn}>
                  <span
                    id="model"
                    style={{ justifyContent: "flex-start" }}
                    className={styles.reservationInputGridModel}
                  >
                    {price.inventorySpecification}
                  </span>
                </Grid>

                <Grid item className={styles.vinColumn}>
                  <span id="model" className={styles.reservationInputGridModel}>
                    {price.vin}
                  </span>
                </Grid>
                <Grid item className={styles.modelYearColumn}>
                  <span id="model" className={styles.reservationInputGridModel}>
                    {price.modelYear}
                  </span>
                </Grid>
                {!props.hideUsdPrice && (
                  <Grid item className={styles.usdConversionColumn}>
                    <span
                      id="model"
                      className={styles.reservationInputGridModelPrice}
                    >
                      USD{" "}
                      {price.currencyAdjustedPrice > 0
                        ? roundToTwoDecimal(
                            price.currencyAdjustedPrice * props.conversionRate
                          )
                        : ""}
                    </span>
                  </Grid>
                )}

                {!props.isMEXMarket && (
                  <Grid item className={styles.previousPriceColumn}>
                    {displayPreviousPrice(price, defaultCurrency)}
                  </Grid>
                )}
                {!props.isMEXMarket && (
                  <Grid
                    item
                    className={styles.previousPriceEffectiveDateColumn}
                  >
                    <div className={styles.previousDiv}>
                      {price.previousPriceEffectiveDate === "" ||
                      price.previousPriceEffectiveDate === null
                        ? "-"
                        : price.previousPriceEffectiveDate}
                    </div>
                  </Grid>
                )}
                {!props.isMEXMarket && (
                  <Grid
                    item
                    className={`${styles.reservationInputGridModel} ${styles.reservationEditPrice} ${styles.currencyAdjustedPriceColumn}`}
                  >
                    <div>
                      {props.editMode ? (
                        <TextField
                          label={defaultCurrency ? defaultCurrency.symbol : ""}
                          autoComplete="off"
                          name={price.vin}
                          variant="outlined"
                          key={"checkbox-row" + index + "-value-"}
                          value={
                            price.currencyAdjustedPrice === null ||
                            price.currencyAdjustedPrice === ""
                              ? ""
                              : price.currencyAdjustedPrice
                          }
                          onChange={props.updateInventoryPrice}
                          error={!!error}
                          helperText={error}
                        />
                      ) : (
                        displayDepositPrice(price, defaultCurrency)
                      )}
                    </div>
                  </Grid>
                )}
                {!props.isMEXMarket && (
                  <Grid item className={styles.spacer}></Grid>
                )}
                <Grid item className={styles.effectiveDateColumn}>
                  <span
                    id="model"
                    className={styles.reservationInputGridRightCell}
                  >
                    {price.effectiveDate}
                  </span>
                </Grid>
                {props.showValidatdColumn && (
                  <Grid item className={styles.clearButtonColumn}>
                    <HasPermissionTo
                      perform={["dealerInventoryDelete:write"]}
                      permissions={props.user.permissions.rolePermissions}
                      render={() => (
                        <Button
                          className={styles.deleteButton}
                          id={`cancelAdd_${price.vin}`}
                          data-testid={`cancelAdd_${price.vin}`}
                          onClick={() => showInventoryConfirmation(price.vin)}
                          size="small"
                        >
                          <ClearIcon />
                        </Button>
                      )}
                    />
                  </Grid>
                )}
              </Grid>
            );
          })}
      </div>
    </div>
  );
};

export default withTranslation("emp")(LoadDealerPricing);
